var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('span',{staticClass:"progress-body"},[_vm._v(" [ "+_vm._s(_vm.progress_line)+" ] ")]),_vm._v(" "+_vm._s(_vm.progress_pct)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }